<template>
  <div v-if="shops">
    <button @click="init" class="btn btn-sm btn-danger mb-4">Обновить</button>
    <div class="row" v-if="date">
      <div class="col-6">
        <label>Дата</label>
        <datetime v-model="date" @input="init" class="from-control" type="date" format="dd/MM/yyyy">
        </datetime>
      </div>
    </div>
    <div class="statuses-items" v-if="shops.length">
      <figure v-for="shop in shops" :key="shop.id" :class="{
        'status-need': shop.visit_status == 1,
        'status-end': shop.visit_status == 2,
      }">
        <div class="fig-wrapper flex ai-center jc-between">
          <div class="p-r-3">
            <div class="fw-6" @click="innerClick(shop)" role="button">{{shop.name}}</div>
            <div>{{ shop.address }}</div>
          </div>
          <div class="ws-nowrap">
            <span v-if="shop.visit_status == 1">Требуется посещение</span>
            <span v-if="shop.visit_status == 2">Посещение завершено</span>
          </div>
        </div>
      </figure>
    </div>
    <div v-else>
      <div class="text-x4-b m-t-5">Маршрутов нет на выбранную дату</div>
    </div>

  </div>
</template>

<script>
import { cardUpdate, cardContent, pushLang } from "@/plugins/functions";

export default {
  data: () => ({
    shops: null,
    visits: null,
    cardLink: "item_shop",
    date: new Date().toISOString(),
  }),
  props: ["id"],
  created() {
    if(this.$route.query['date'])
      this.date = new Date(this.$route.query['date']).toISOString()
    this.init()
  },
  methods: {
    cardUpdate: cardUpdate,
    cardContent: cardContent,
    pushLang: pushLang,
    async init(){
      var data = await this.cardContent("/users", `${this.id}/visits`, {date: this.date.split('T')[0]}, true);
      if(!data && !data.data)
        return
      this.shops = data.data
      this.visits = data.visited_shops
      this.shops.forEach(e=>{
        if(this.visits.some(j=>{return j == e.id}))
          e.visit_status = 2
        else
          e.visit_status = 1
      })
    },
    innerClick(item) {
      const element = `${this.cardLink}`;
      let query = Object.assign({}, this.$route.query);
      if (query[element] == item.id) {
        return false;
      }
      if (query[element]) {
        delete query[element];
      }
      query[element] = item.id;
      setTimeout(() => {
        this.$router.replace({ query: query });
      }, 20);
    },
    // async updateItem() {
    //   let item = await this.cardUpdate(this.cardSetLink, this.item, this.fields);
    // },
  },
};
</script>
<style lang="scss">
  .statuses-items{
    figure{
      margin-top: 5px;
      margin-bottom: 5px;
      .fig-wrapper{
        position: relative;
        padding: 8px 15px;
        padding-right: 40px;
        z-index: 1;
        border-radius: 8px;
        background-color: #f3f3f3;
        &:before{
          border-radius: 0 8px 8px 0;
          z-index: -1;
          position: absolute;
          content: "";
          right: 0;
          top: 0;
          width: 10px;
          height: 100%;
          display: block;
          background-color: #e1e1e1;
          background-color: var(--color-3);
        }
      }
      
      &.status-need{
        .fig-wrapper:before{
          background-color: var(--color-2);
        }
      }
    }
  }
</style>
